import { render, staticRenderFns } from "./text_footer.vue?vue&type=template&id=4a5ff4a8&"
import script from "./text_footer.vue?vue&type=script&lang=js&"
export * from "./text_footer.vue?vue&type=script&lang=js&"
import style0 from "./text_footer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports